import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: colors.lightBlue.darken3, // #00B0FF
                secondary: colors.indigo.darken4, // #0091EA
                accent: colors.indigo.base, // #3F51B5
            },
        },
    },
});
